export const MEMBER_GROUP_LIST_PAGE_PATH = '/member/group/list'
